"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { INotificationIdentityMentioned } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter } from "next/navigation";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
export default function NotificationIdentityMentioned(t0) {
  const $ = _c(48);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  const baseWave = notification.related_drops[0].wave as any;
  const baseIsDm = baseWave.chat?.scope?.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isApp || $[1] !== router) {
    t1 = (waveId, serialNo, isDirectMessage) => {
      router.push(getWaveRoute({
        waveId,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const navigateToDropInWave = t1;
  let t2;
  if ($[3] !== baseIsDm || $[4] !== baseWave.id || $[5] !== navigateToDropInWave) {
    t2 = serialNo_0 => {
      navigateToDropInWave(baseWave.id, serialNo_0, baseIsDm);
    };
    $[3] = baseIsDm;
    $[4] = baseWave.id;
    $[5] = navigateToDropInWave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onReplyClick = t2;
  let t3;
  if ($[7] !== baseIsDm || $[8] !== navigateToDropInWave) {
    t3 = quote => {
      const quoteWave = quote.wave as any;
      const quoteIsDm = quoteWave?.chat?.scope?.group?.is_direct_message ?? baseIsDm;
      navigateToDropInWave(quote.wave.id, quote.serial_no, quoteIsDm);
    };
    $[7] = baseIsDm;
    $[8] = navigateToDropInWave;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onQuoteClick = t3;
  let t4;
  if ($[10] !== notification.related_drops[0].author.pfp) {
    t4 = <div className="tw-h-7 tw-w-7">{notification.related_drops[0].author.pfp ? <img src={getScaledImageUri(notification.related_drops[0].author.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[10] = notification.related_drops[0].author.pfp;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = notification.related_drops[0].author.handle ?? "";
  const t6 = `/${notification.related_drops[0].author.handle}`;
  let t7;
  if ($[12] !== notification.related_drops[0].author.handle || $[13] !== t6) {
    t7 = <Link href={t6} className="tw-no-underline tw-font-semibold tw-text-sm tw-text-iron-50">{notification.related_drops[0].author.handle}</Link>;
    $[12] = notification.related_drops[0].author.handle;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <UserProfileTooltipWrapper user={t5}>{t7}</UserProfileTooltipWrapper>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">mentioned you</span>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== notification.created_at) {
    t11 = getTimeAgoShort(notification.created_at);
    $[20] = notification.created_at;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t10}{" "}{t11}</span>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t8) {
    t13 = <span className="tw-inline-flex tw-flex-wrap tw-gap-x-1 tw-items-center">{t8}{" "}{t9}{" "}{t12}</span>;
    $[24] = t12;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t4) {
    t14 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t4}{t13}</div>;
    $[27] = t13;
    $[28] = t4;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== notification.related_drops[0].author) {
    t15 = <NotificationsFollowBtn profile={notification.related_drops[0].author} size={UserFollowBtnSize.SMALL} />;
    $[30] = notification.related_drops[0].author;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = <div className="tw-flex tw-flex-1 tw-justify-between tw-gap-x-4 tw-gap-y-1">{t14}{t15}</div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== notification.related_drops[0]) {
    t17 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[35] = notification.related_drops[0];
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== activeDrop || $[38] !== onDropContentClick || $[39] !== onQuote || $[40] !== onQuoteClick || $[41] !== onReply || $[42] !== onReplyClick || $[43] !== t17) {
    t18 = <Drop drop={t17} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[37] = activeDrop;
    $[38] = onDropContentClick;
    $[39] = onQuote;
    $[40] = onQuoteClick;
    $[41] = onReply;
    $[42] = onReplyClick;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t18) {
    t19 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t16}{t18}</div></div>;
    $[45] = t16;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
}